import { useTheme} from "@healthcatalyst/react-cashmere";
const makeSxStyles = (styleFn) => {
  return () => {
    const [theme] = useTheme();
    return styleFn(theme);
  };
};

export default makeSxStyles;